import { render } from "./DisplayNotifications.vue?vue&type=template&id=b396fe5a&scoped=true"
import script from "./DisplayNotifications.vue?vue&type=script&lang=js"
export * from "./DisplayNotifications.vue?vue&type=script&lang=js"

import "./DisplayNotifications.vue?vue&type=style&index=0&id=b396fe5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b396fe5a"]])

export default __exports__